<template>
  <div
    v-if="attachments.length"
    class="tw-border-solid tw-border tw-border-sf-snow-dark tw-rounded-md"
  >
    <div
      v-for="(attachment, index) in attachments"
      :key="attachment.document_id"
      class="
        tw-flex
        tw-items-center
        tw-justify-between
        tw-px-3
        tw-py-2
        tw-border-solid
        tw-border-0
        tw-border-sf-snow-dark
      "
      :class="{ 'tw-border-b': index !== attachments.length - 1 }"
    >
      <span class="tw-text-sm">{{ attachment.name }}</span>
      <div
        class="tw-flex tw-items-center tw-justify-center tw-text-sf-gray-dark"
      >
        <div v-if="attachment.size" class="tw-mr-2 tw-text-[11px]">
          {{ formatBytes(attachment.size) }}
        </div>
        <AttachmentListItemActions
          :attachment="attachment"
          :changes-are-disabled="changesAreDisabled"
          @delete-attachment="emit('deleteAttachment', attachment)"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Attachment } from './types'

import { formatBytes } from '@app/utils/file-helpers'
import AttachmentListItemActions from './attachment-list-item-actions.vue'

interface Props {
  attachments: Attachment[]
  changesAreDisabled: boolean
}

defineProps<Props>()

const emit =
  defineEmits<{
    deleteAttachment: [attachment: Attachment]
  }>()
</script>
